import { Directive, ElementRef, inject } from '@angular/core';

/**
 * @description This directive is meant to be attached to the
 *   **body** element of the OkePanel instance—usually a
 *   `<section />`—and this directive then adds the
 *   appropriate className to it
 */
@Directive({
  selector: '[okePanelBody]'
})
export class Body {
  private readonly _elem: ElementRef = inject(ElementRef);

  constructor() {
    this._elem.nativeElement.classList.add('body');
  }
}
